module.exports = __webpack_public_path__ + "img/ep-arc-en-ciel2.9ed591d5.jpg";